module.exports = {
  cash: "cash",
  creditCard: "creditCard",
  payPal: "payPal",
  subscriber: "subscriber",
  creditCardInTaxi: "creditCardInTaxi",
  bizum: "bizum",
};
